import script from "./msgbox.vue?vue&type=script&setup=true&lang=js"
export * from "./msgbox.vue?vue&type=script&setup=true&lang=js"

import "./msgbox.vue?vue&type=style&index=0&id=e3b2c4f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3b2c4f0"]])

export default __exports__